var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lock-chart-wrapper"},[_c('EmptyRadarChart',{attrs:{"dimension":_vm.dimension}}),_c('div',{staticClass:"lock-chart-wrapper__slot-wrapper"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }